// removed by extract-text-webpack-plugin
module.exports = {"easyHeading":"styles__easyHeading__1A7Zj","howItWorks":"styles__howItWorks__2Wa7S","list":"styles__list__3Jdpw","number":"styles__number__3kUQ5","image":"styles__image__1I7_Z","budge":"styles__budge__3SWOx","description":"styles__description__2mDmz"};


//////////////////
// WEBPACK FOOTER
// ./src/components/HowItWorks/styles.scss
// module id = 395
// module chunks = 0